import { render } from "./BaseCard.vue?vue&type=template&id=73b3db5c&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=73b3db5c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b3db5c"]])

export default __exports__